<template>
  <div
    :id="uuid"
    class="overflow-x-scroll max-w-full"
    :class="formData.menuStyle === 'bg' && 'py-2 px-4 bg-white rounded-xl '"
    style="scroll-margin-top: calc(4rem + env(safe-area-inset-top))"
  >
    <div
      v-if="!formData.items.length"
      class="text-red-700 text-lg bg-white text-center"
    >
      {{ $t('admin.menu_block_no_items') }}
    </div>
    <div v-else class="flex items-center gap-2">
      <div v-for="(item, index) in formData.items" :key="index">
        <BaseButton
          v-if="item.isExternalLink && item.externalLink"
          look="none"
          :class="buttonBgStyle"
          rounded="xl"
          size="md"
        >
          <BaseLink
            :href="item.externalLink"
            target="_blank"
            :class="buttonTextStyle"
          >
            {{ item.title }}
          </BaseLink>
        </BaseButton>
        <template v-if="!item.isExternalLink && item.blockHash">
          <BaseButton
            v-if="item.isBlank"
            look="none"
            :class="buttonBgStyle"
            rounded="xl"
            size="md"
          >
            <BaseLink
              :href="getBlockLink(item.blockHash)"
              target="_blank"
              :class="buttonTextStyle"
            >
              {{ item.title }}
            </BaseLink>
          </BaseButton>
          <BaseButton
            v-else
            look="none"
            rounded="xl"
            size="md"
            :class="buttonBgStyle"
            @click="scrollToHash(item.blockHash)"
          >
            <span :class="buttonTextStyle">
              {{ item.title }}
            </span>
          </BaseButton>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface PageEditorMenuItem {
  title: string
  isExternalLink: boolean
  isBlank: boolean
  blockHash?: string
  externalLink?: string
}

interface FormDataInterface {
  menuStyle: 'separate' | 'bg'
  items: PageEditorMenuItem[]
}

interface PropsInterface {
  uuid: string
  formData: FormDataInterface
  isInIframe?: boolean
}

const props = withDefaults(defineProps<PropsInterface>(), {
  isInIframe: false,
})

const { pushNotification } = useNotifications()
const route = useRoute()
const host = useHost()

const getBlockLink = (hash: string) => {
  return `${host}${route.path}#${hash}`
}

function scrollToHash(hash: string) {
  const element = document.querySelector(`#${hash}`)
  if (!element) {
    pushNotification({
      title: 'No block with such hash on the page',
      theme: 'destructive',
    })
    return
  }
  element.scrollIntoView({ behavior: 'smooth' })
}

const buttonTextStyle = 'text-gray-900 hover:text-gray-900 focus:text-gray-900'

const buttonBgStyle = computed(() => {
  return `bg-white ${
    props.formData.menuStyle === 'separate'
      ? 'hover:bg-ocean'
      : 'hover:bg-primary-100'
  }`
})
</script>
